// React
import React from "react";

// Helper Imports
import { formatDate } from "../../../../../Helpers/formatters";

// MUI Imports
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

const CallNotesBody = ({
  callNotes,
  page,
  rowsPerPage, 
}) => {
  return (
    <TableBody>
      {callNotes
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => {
        return (
          <TableRow key={index}>
            <TableCell className="tableCell" align="center">
              {row.orderId}
            </TableCell>
            <TableCell className="tableCell" align="center">
              {row.callNoteContent}
            </TableCell>
            <TableCell className="tableCell" align="center">
              {row.dispositionDescription}
            </TableCell>
            <TableCell className="tableCell" align="center">
              {row.displayName}
            </TableCell>
            <TableCell className="tableCell" align="center">
              {formatDate(row.noteDate)}
            </TableCell>
            <TableCell className="tableCell" align="center"></TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
};

export default CallNotesBody;
